import React__default, { forwardRef, useRef, useState, useImperativeHandle, useCallback } from 'react';
import dayjs from 'dayjs';
import { useTheme } from '@emotion/react';
import useConfig from '../../../Hooks/useConfig.js';
import { appService } from '../../../Hooks/Contexts.js';
import utc__default from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ReactDatePickerRenderer from './ReactDatePickerRenderer.js';
import renderCustomHeader from './RenderCustomHeader.js';
import DatePickerInModal from './DatePickerInModal.js';

dayjs.extend(utc__default);
dayjs.extend(customParseFormat);
const DatePicker = forwardRef((props, ref) => {
    const theme = useTheme();
    const config = useConfig();
    const { placeholderText, date, customInput, onChange, dataTestId, withHeader, locale = appService.lang || config.defaultLanguage, noDatePickerOverflow, onCalendarOpen, onCalendarClose, minDate, maxDate, customCalendarContainer, focusSelectedMonth, withKeyboardSupport, setValueToNullWhenFormatIsIncorrect, onInvalidInputFormat, updatePackageAvailability, showInModal, inline, onMonthChange, renderDayContents, noInitialValueInput } = props;
    const reactDatePickerRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    useImperativeHandle(ref, () => ({
        openDatePicker() {
            reactDatePickerRef?.current?.setOpen(true);
        },
        closeDatePicker() {
            reactDatePickerRef?.current?.setOpen(false);
        },
        forceUpdate() {
            reactDatePickerRef?.current?.forceUpdate();
        }
    }));
    const toggleDropdown = useCallback(() => {
        setIsModalOpen(value => !value);
    }, []);
    const onInputChange = useCallback((newDate) => {
        if (setValueToNullWhenFormatIsIncorrect && onInvalidInputFormat && !newDate) {
            onInvalidInputFormat();
        }
        if (!!onChange && newDate) {
            onChange(newDate);
        }
    }, [setValueToNullWhenFormatIsIncorrect, onChange, onInvalidInputFormat]);
    const handleMonthChange = useCallback((onMonthChangeDate) => {
        if (!!updatePackageAvailability) {
            updatePackageAvailability(onMonthChangeDate);
        }
        if (!!onMonthChange) {
            onMonthChange(onMonthChangeDate);
        }
    }, [updatePackageAvailability, onMonthChange]);
    return showInModal ? (React__default.createElement(DatePickerInModal, { ...props, onChange: onChange, onInputChange: onInputChange, toggleDropdown: toggleDropdown, isModalOpen: isModalOpen },
        React__default.createElement(ReactDatePickerRenderer, { ...props, theme: theme, reactDatePickerRef: reactDatePickerRef, dataTestId: dataTestId, locale: locale, calendarContainer: customCalendarContainer, withHeader: withHeader, renderCustomHeader: renderCustomHeader, renderDayContents: renderDayContents, showInModal: showInModal, toggleDropdown: toggleDropdown, onChange: onChange, onCalendarOpen: onCalendarOpen, onCalendarClose: onCalendarClose, customInput: customInput, withKeyboardSupport: withKeyboardSupport, placeholderText: placeholderText, selected: date, focusSelectedMonth: focusSelectedMonth, minDate: minDate, maxDate: maxDate, onMonthChange: handleMonthChange, onInputChange: onInputChange, inline: true, noDatePickerOverflow: noDatePickerOverflow, noInitialValueInput: noInitialValueInput }))) : (React__default.createElement(ReactDatePickerRenderer, { ...props, theme: theme, reactDatePickerRef: reactDatePickerRef, dataTestId: dataTestId, locale: locale, calendarContainer: customCalendarContainer, withHeader: withHeader, renderCustomHeader: renderCustomHeader, renderDayContents: renderDayContents, showInModal: showInModal, toggleDropdown: toggleDropdown, onChange: onChange, onCalendarOpen: onCalendarOpen, onCalendarClose: onCalendarClose, customInput: customInput, withKeyboardSupport: withKeyboardSupport, placeholderText: placeholderText, selected: date, focusSelectedMonth: focusSelectedMonth, minDate: minDate, maxDate: maxDate, onMonthChange: handleMonthChange, onInputChange: onInputChange, inline: inline, noDatePickerOverflow: noDatePickerOverflow, noInitialValueInput: noInitialValueInput }));
});

export { DatePicker as default };
//# sourceMappingURL=DatePicker.js.map
